import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const FullScreenLoader = ({ open }) => (
  <Backdrop
    sx={{ color: '#fff', zIndex: 1400 }}
    open={open}
  >
    <CircularProgress color="inherit" size="4rem" />
  </Backdrop>
);

export default FullScreenLoader;
